import { render } from "./WelcomeItem.vue?vue&type=template&id=6fcb84ec&scoped=true"
const script = {}

import "./WelcomeItem.vue?vue&type=style&index=0&id=6fcb84ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcb84ec"]])

export default __exports__